import React from "react";
import { PanelEditWhatsappGroup } from "../../../../UI/Groups/Whatsapp/Edit/PanelEditWhatsappGroup";

const EditWhatsappGroup = () => {
  return (
    <div>
      <PanelEditWhatsappGroup />
    </div>
  );
};

export default React.memo(EditWhatsappGroup);
